import common from "@charmdeer/common";
import { get, isObject } from "lodash-es";

const getTextByLanguage = (value, language) => {
  if (!isObject(value)) return value;

  return (
    get(value, language) ||
    get(value, common.locale.getI18nStyle(language)) ||
    get(value, "zh") ||
    get(value, "zh_TW") ||
    get(value, "en") ||
    get(value, "local") ||
    ""
  );
};

const getCityShowLabel = (city, language) => {
  const formattedName = common.city.toString.name(city, language);
  const textName = getTextByLanguage(formattedName, language);

  return (
    textName ||
    getTextByLanguage(city?.city, language) ||
    getTextByLanguage(city?.name, language) ||
    getTextByLanguage(city?.province, language) ||
    getTextByLanguage(city?.country, language) ||
    get(city, `translation.${common.locale.getI18nStyle(language)}.name`) ||
    get(city, "translation.en.name") ||
    get(city, "translation.local.name") ||
    ""
  );
};

export const getHotelCityLocation = (hotel, language) => {
  const city = hotel?.city;
  if (!city?._id) return null;

  return {
    ...city,
    locationType: "city",
    showLabel: getCityShowLabel(city, language)
  };
};

export const syncHotelDetailLocation = (store, hotel, language) => {
  const location = getHotelCityLocation(hotel, language);
  if (!location) return {};

  store.SET_HOTEL_SEARCH_MODEL({
    location,
    locationRef: location._id,
    locationType: "city",
    filter: {
      city: { _id: location._id }
    }
  });

  return {
    locationType: "city",
    locationRef: location._id,
    showLabel: location.showLabel
  };
};
